require("./src/ajaxhook")(module.exports)
